import axios from "axios";
import { useEffect, useState } from "react";

const useModerator = (user) => {
  const [moderator, setModerator] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const userEmail = user?.email;
    if (userEmail) {
      setIsLoading(true); // Ensure loading state is updated when fetching starts
      axios
        .get(`${process.env.REACT_APP_BACKEND_API}/users/roles/${userEmail}`)
        .then((res) => {
          setModerator(res.data.isModerator);
        })
        .catch((error) => {
          console.error("Error fetching moderator status:", error);
          setModerator(false); // Ensure it defaults to false if an error occurs
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [user?.email]); // Depend only on userEmail

  return [moderator, isLoading];
};

export default useModerator;
